import { MergeEntityName } from "@/api-schema-enums";
import { MergeDialog, MergeEntityRef } from "@/components/merge/merge-dialog";

interface BrandMergeDialogProps {
  open: boolean;
  source: MergeEntityRef;
  sourceLogoUrl?: string;
  onClose: () => void;
}

export const BrandMergeDialog = ({ open, source, sourceLogoUrl, onClose }: BrandMergeDialogProps) => {
  return (
    <MergeDialog
      open={open}
      entity={MergeEntityName.Brand}
      source={source}
      sourceLogoUrl={sourceLogoUrl}
      onClose={onClose}
    />
  );
};
